import { HierarchicalAutocomplete } from "@/Components/v2/atoms/Autocomplete";
import { EnhancedOption, HierarchicalOption } from "@/Components/v2/atoms/Autocomplete/types";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { SearchableSelectField } from "@/Components/v2/molecule/SearchableSelectField";
import { TypographyWithInfoTooltip } from "@/Components/v2/molecule/TypographyWithTooltip";

interface LabelledHierarchyAutoCompleteProps {
  label: string;
  id: string;
  options: HierarchicalOption[];
  width?: number;
  onSelectChange: (selected: EnhancedOption) => void;
  disableClearable?: boolean;
  value: string;
  infoTitle?: string;
  infoText?: string;
  disabled?: boolean;
}

export const LabelledHierarchyAutoComplete: React.FC<LabelledHierarchyAutoCompleteProps> = ({
  label,
  id,
  onSelectChange,
  options,
  width,
  disableClearable = false,
  value,
  infoTitle,
  infoText,
  disabled = false,
}) => {
  const handleSelection = (selected: EnhancedOption | null) => {
    if (selected === null || selected === undefined) {
      return;
    }

    onSelectChange(selected);
  };

  return (
    <Stack>
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        {infoTitle && infoText ? (
          <TypographyWithInfoTooltip label={label} infoTitle={infoTitle} infoText={infoText} />
        ) : (
          <Typography fontWeight={600} variant="body1">
            {label}
          </Typography>
        )}
      </Stack>
      <HierarchicalAutocomplete
        sx={{ width: width }}
        disabled={disabled}
        id={id}
        options={options}
        disableClearable={disableClearable}
        onChange={(value) => handleSelection(value)}
        value={value}
        defaultValue={options[0]}
        renderInput={(params) => {
          return <SearchableSelectField {...params} placeHolder={label} />;
        }}
      />
    </Stack>
  );
};

export default LabelledHierarchyAutoComplete;
